<template>
    <div class="modal-wrapper" :class="{hide: !modals.newPassword}" v-on:click.stop="hideModal">
        <div class="modal" v-on:click.stop>
            <div class="title-wrapper">
                <BaseModalTitle>
                    <template #left>
                        <div class="modal-title-left">
                            <span class="title__medium">{{ tokens.newPasswordModal.setNewPassword }}</span>
                        </div>
                    </template>
                </BaseModalTitle>
            </div>
            <div class="modal-box">
                <BaseInput
                    v-model="newPassword"
                    :title="tokens.newPasswordModal.newPassword"
                    name="password"
                    :type="'password'"
                    :placeholder="tokens.newPasswordModal.newPassword"
                />
                <BaseInput
                    v-model="confirmedNewPassword"
                    :title="tokens.newPasswordModal.confirmNewPassword"
                    name="password"
                    :type="'password'"
                    :placeholder="tokens.newPasswordModal.confirmNewPassword"
                />
            </div>
            <div class="modal-footer">
                <BaseButton
                    :button-style="'filled-primary'"
                    :button-text="tokens.newPasswordModal.setButton"
                    :disabled="!newPassword || !confirmedNewPassword || newPassword !== confirmedNewPassword"
                    @click.native="setNewPassword"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import {PASSWORD_RESET} from '@/store/actions.type'
import {MODAL, NOTIFICATION_ERROR} from "@/store/mutations.type"
import {hidePass, showPass} from "@/common/helpers";
import BaseInput from "../../shared/ui/Inputs/BaseInput.vue";
import BaseButton from "../../shared/ui/buttons/BaseButton.vue";
import BaseModalTitle from "../../shared/ui/titles/BaseModalTitle.vue";

export default {
    name: "NewPasswordModal",
    components: {BaseModalTitle, BaseButton, BaseInput},
    data() {
        return {
            newPassword: '',
            confirmedNewPassword: ''
        }
    },
    methods: {
        showPass,
        hidePass,
        setNewPassword() {
            if (this.newPassword === this.confirmedNewPassword) {
                this.$store.dispatch(PASSWORD_RESET, {
                    password: this.newPassword
                })
            } else {
                this.$store.commit(NOTIFICATION_ERROR, 'LOCAL_PASSWORDS_NOT_MATCH')
            }
        },
        hideModal() {
            this.$store.commit(MODAL, {
                newPassword: false
            })
        }
    },
    computed: {
        ...mapGetters(['modals', 'tokens'])
    }
}
</script>

<style scoped>
.modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.new-design.mobile.banner-is-active .modal-wrapper,
.new-design.mobile.banner-is-active .modal-otp {
    height: calc(100% - 44px);
}

.modal-wrapper,
.modal-otp {
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    top: auto;
}

.theme_3-logo {
    display: inline-block;
    width: max-content;
    position: absolute;
    top: 5px;
    left: 10px;
}

.modal {
    width: 280px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 25px 28px;
    z-index: 1100;
    border-radius: 8px;
    border: 1px solid var(--System-OutlineVariant);
    background: var(--System-Surface1);
    position: relative;
}

.title-wrapper {
    margin-bottom: 34px;
}

.modal-title-left {
    color: var(--System-OnSurface);
    display: flex;
    align-items: center;
    gap: 12px;
}

.modal-title-left i {
    font-size: 18px;
}

.modal-title-right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 10px;
}

.modal-box {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 40px;
}

.modal-footer button {
    width: 100%;
}

@media(max-width: 768px){
    .modal{
        margin: 15px;
    }
}
</style>
